const TabButtonWrapper = ({ children }) => {
  return (
    <div className="flex items-center gap-1 bg-gray-100/80 p-1 rounded-xl border border-gray-100 backdrop-blur">
      {children}
    </div>
  )
}

export default TabButtonWrapper
